module.exports = __webpack_public_path__ + "img/324.8959041d.png";